$(document).on('click', '.icon_clear', function(e){
  $(".banner-index_search_input").val('');
});

$(".banner-index_search_input").keypress(function(event) {
  if (event.which === 13) {
    var value_keyword = $(this).val();
    if (value_keyword.length > 0) {
      window.location.href = Routes.jobs_path({
        keyword: value_keyword,
      });
    } else {
      window.location.href = Routes.jobs_path();
    }
  }
});

$(".banner-index_search_input").keyup(function(event) {
  if ($(this).val().length > 0) {
    $(".icon_clear").removeClass('d-none');
  } else {
    $(".icon_clear").addClass('d-none');
  }
});